import React from 'react';
import { Button, View } from '@upstox/upstox-ui';
import * as css from 'app/components/MainLayout/components/Modal/styles';

type TModalFooter = {
  isSubmitting?: boolean
  disabledSubmitting?: boolean
  onConfirm?: () => void
  onClose: () => void
  confirmActionTitle?: string,
  hideConfirmButton?: boolean,
}

export const ModalFooter: React.FC<TModalFooter> = (props) => {
  const {
    onConfirm,
    onClose,
    confirmActionTitle,
    isSubmitting,
    disabledSubmitting,
    hideConfirmButton = false,
  } = props;

  return (
    <View padding="xlarge" gap="small" justifyContent="flex-end" css={css.footer}>
      <Button size="small" variant="secondary" onClick={onClose}>Cancel</Button>
      {!hideConfirmButton && (
        <Button
          size="small"
          onClick={onConfirm}
          isLoading={isSubmitting}
          disabled={disabledSubmitting}
        >
          {confirmActionTitle}
        </Button>
      )}
    </View>
  );
};
